(function () {
    'use strict';

    let module = angular.module('imApp');

    module.component('srOperationManualAdd', {
        templateUrl: 'views/components/views/srOperationManualAdd/srOperationManualAdd.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['stateService', 'modalService', 'srOperationManualAddService', function (stateService, modalService, srOperationManualAddService) {

            // #region VARIABLES & DEFINITIONS

            var vm = this;

            vm.model = {
                edit: {},
                selectListHrsNo: [],
                selectListResources: [],
                lockedSave: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region LOAD PROCEDURE FUNCTION CALLS

            srOperationManualAddService.getSrOperationManualAdd().then(function (data) {
            	angular.copy(data[0], vm.model.edit);
            });

            srOperationManualAddService.listHrsNo().then(function (data) {
                angular.copy(data, vm.model.selectListHrsNo);
            });

            srOperationManualAddService.listResources().then(function (data) {
                angular.copy(data, vm.model.selectListResources);
            });

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region SAVE PROCEDURE FUNCTION CALL

            vm.saveSrOperationManualAdd = function () {
                vm.model.lockedSave = true;
                
                srOperationManualAddService.saveObj(vm.model.edit).then(function (data) {
                    if (data[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: 'Varsel',
                            message: data[0].errormessage,
                            buttons: [{
                                label: 'OK',
                                cssClass: 'btn-warning',
                                action: function (dialogItself) {
                                    dialogItself.close();
                                    vm.model.lockedSave = false;
                                }
                            }]
                        });
                    } else {
                        vm.model.lockedSave = false;
                        stateService.back();
                    }
                });
            };

		    // #endregion SAVE PROCEDURE FUNCTION CALL
        }]
    });
})();
